export default __webpack_public_path__ + "static/media/calibration-print.55ef7339.svg";